import React from "react";
import PropTypes from "prop-types";
import { Table, Toolbar } from "./components";
import { connect } from "react-redux";

const History = (props) => {
  const { history } = props;

  return (
    <div className="history-page" style={{ padding: '32px' }}>
      <div className="history-header" style={{ marginBottom: '24px' }}>
        <Toolbar history={history} />
      </div>
      <Table list={props.list} />
    </div>
  );
};

History.propTypes = {
  className: PropTypes.string,
  history: PropTypes.object
};

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.token,
    list: reducer.history.list,
    error: reducer.history.error,
    loading: reducer.history.loading,
    search: reducer.history.search,
  };
}

export default connect(mapStateToProps)(History);
